module.exports = __webpack_public_path__ + "media/images/welcome_screen_mobile-99ec3e03700c2ccc1f7b92a673773597.png";